import React, { useEffect, useState } from "react";
import { number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { getPollData } from "../../helper/api";

import "./poll-card.m.css";

const PollCard = ({ polltypeId, index, pollTypeHostUrl }) => {
  const [pollData, setPollData] = useState(null);

  useEffect(() => {
    getPollData(setPollData, pollTypeHostUrl, polltypeId);
  }, []);

  if (!pollData) {
    return null;
  }

  const { topic, "total-votes": totalVotes, opinions } = pollData;

  return (
    <div styleName="base">
      <div styleName="poll-number">{`Poll ${index + 1}`}</div>
      {topic && <div styleName="poll-description">{topic}</div>}
      <div styleName="key-value-wrapper">
        <span styleName="key">Total votes: </span>
        {totalVotes}
      </div>
      {opinions &&
        opinions.length > 0 &&
        opinions.map((item, index) => {
          const individualCount = Math.round((totalVotes * item["percentage-votes"]) / 100);

          return (
            <div styleName="key-value-wrapper" key={index}>
              <span styleName="key">{`${item.text}: `}</span>
              {`${individualCount} (${item["percentage-votes"]}%)`}
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  pollTypeHostUrl: get(state, ["qt", "config", "publisher-attributes", "pollTypeHostUrl"], null),
});

PollCard.propTypes = {
  polltypeId: number,
  index: number,
  pollTypeHostUrl: string,
};

export default connect(mapStateToProps)(PollCard);
